import { render, staticRenderFns } from "./FullCalendarHeader.vue?vue&type=template&id=af5d16b4&"
import script from "./FullCalendarHeader.vue?vue&type=script&lang=js&"
export * from "./FullCalendarHeader.vue?vue&type=script&lang=js&"
import style0 from "./FullCalendarHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports